import { BlockAdapter } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/ContentEditor/adapters/blocks/blockAdapter.types'
import { createPhasesBlock } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/utils/createPhasesBlock'

export const phasesAdapter: BlockAdapter<'phases'> = {
  in: () => {
    return [
      {
        type: 'phases'
      }
    ]
  },
  out: ctx => () => createPhasesBlock(ctx.cubeQueries)
}
